import styled from 'styled-components';
import { ml } from '@lendi-ui/spacing';
import LUITooltip from '@lendi-ui/tooltip';

export const Tooltip = styled(LUITooltip)`
  ${ml('xs')};
`;
